<template>
	<v-app>
		<div v-if="$myStore.state.loaderCount > 0" class="loader">
			<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
		</div>

		<v-dialog v-model="alertModal.show" max-width="480">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text class="grey--text text--darken-2" v-html="alertModal.text"></v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="alertModal.show = false">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="verifyModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2" v-html="verifyModal.text"></v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="verifyModal.result(true)">{{ $t('buttons.yes') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModal.result(false)">{{ $t('buttons.no') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="promptModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2">
					<InputField v-model="promptModal.value" :label="promptModal.text"></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="promptModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="promptModal.result(false)">{{ $t('buttons.cancel') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar
			v-model="notification.show"
			:timeout="3000"
			:top="true"
			class="notification black--text text-center"
			color="primary"
			>{{ notification.text }}
		</v-snackbar>

		<template v-if="$myStore.state.loggedIn">
			<v-app-bar app clipped-left dark dense flat>
				<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
				<v-img
					:max-height="40"
					:max-width="70"
					:src="publicPath + 'mh-logo-clanstvo-01.svg'"
					style="cursor: pointer; margin-left: 10px"
					@click="logoReroute"
				/>
				<v-breadcrumbs :items="$myStore.state.breadcrumbs" divider=">"></v-breadcrumbs>
				<v-spacer></v-spacer>
				<div :class="['text-subtitle-1', 'grey--text']">
					{{ $myStore.state.user.first_name + ' ' + $myStore.state.user.last_name }}
				</div>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn depressed icon v-bind="attrs" @click="logoutClick" v-on="on">
							<v-icon small>fa-sign-out-alt</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('tooltips.logout') }}</span>
				</v-tooltip>
			</v-app-bar>
			<v-navigation-drawer v-model="drawer" app clipped dark>
				<v-list dense>
					<div class="navigation-items">
						<v-list-item
							:to="{ path: '/members' }"
							v-if="
								$myStore.state.user.userPermission.members_personal_info != 0 ||
								$myStore.state.user.userPermission.members_bookstore != 0
							"
						>
							<v-list-item-icon>
								<v-icon>fa-users</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.members') }}</v-list-item-title>
						</v-list-item>
						<v-list-item
							:to="{ path: '/branches' }"
							v-if="
								$myStore.state.user.userPermission.branches != 0 ||
								$myStore.state.user.userPermission.departments != 0
							"
						>
							<v-list-item-icon>
								<v-icon>fa-building</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.branches') }}</v-list-item-title>
						</v-list-item>
						<v-list-item
							:to="{ path: '/payments' }"
							v-if="$myStore.state.user.userPermission.payments != 0"
						>
							<v-list-item-icon>
								<v-icon>fa-money-bill</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.payments') }}</v-list-item-title>
						</v-list-item>
						<v-list-item
							:to="{ path: '/subscriptions' }"
							v-if="$myStore.state.user.userPermission.subscriptions != 0"
						>
							<v-list-item-icon>
								<v-icon>fa-newspaper</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.subscriptions') }}</v-list-item-title>
						</v-list-item>
						<!-- <v-list-item :to="{ path: '/reports' }" v-if="$myStore.state.user.userPermission.reports != 0">
							<v-list-item-icon>
								<v-icon>fa-clipboard-list</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.reports') }}</v-list-item-title>
						</v-list-item> -->
						<v-list-group
							no-action
							v-model="$myStore.state.subMenuSettings"
							v-if="$myStore.state.user.userPermission.settings != 0"
						>
							<v-icon slot="prependIcon" small color="white">fa-cog</v-icon>
							<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
							<template v-slot:activator>
								<v-list-item-title>{{ $t('modules.settings') }}</v-list-item-title>
							</template>
							<v-list-item :to="{ path: '/codebooks' }">
								<v-list-item-icon>
									<v-icon>fa fa-book</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.codebooks') }}</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ path: '/user-accounts' }">
								<v-list-item-icon>
									<v-icon>fa-users-gear</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.userAccounts') }}</v-list-item-title>
							</v-list-item>
						</v-list-group>
						<v-list-item @click="adminUserManual()" v-if="$myStore.state.user.email === 'dev@ide3.hr'"
							><v-list-item-icon>
								<v-icon>fas fa-file-arrow-up</v-icon>
							</v-list-item-icon>

							<v-list-item-title>{{ $t('modules.userManual') }}</v-list-item-title>
						</v-list-item>

						<v-list-item
							class="bottom mb-10"
							@click="openUserManual()"
							v-if="userManual !== null && userManual != '' && userManual != undefined"
							><v-list-item-icon>
								<v-icon>fas fa-file-pdf</v-icon>
							</v-list-item-icon>

							<v-list-item-title>{{ $t('modules.userManual') }}</v-list-item-title>
						</v-list-item>
					</div>
					<div class="menu-footer" v-html="$getSettings('FOOTER_HTML')"></div>
				</v-list>
			</v-navigation-drawer>
		</template>
		<v-main v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view></router-view>
			</transition>
		</v-main>
		<v-dialog persistent v-model="userManualDialog" width="600">
			<v-card>
				<v-card-title class="pl-15 text-ht grey lighten-2">
					{{ $t('labels.userManual') }}
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col class="py-10">
							<Upload v-model="userManual.document"></Upload>
						</v-col>
					</v-row>
				</v-card-text>

				<v-row class="pb-3 ma-0">
					<v-col cols="12" md="6" class="text-right">
						<v-btn color="primary" class="white--text" @click.stop="saveUserManual">
							{{ $t('buttons.save') }}
						</v-btn>
					</v-col>
					<v-col cols="12" md="6" class="text-left">
						<v-btn color="secondary" class="white--text" @click.stop="closeUserManualDialog">
							{{ $t('buttons.cancel') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-card></v-dialog
		>
	</v-app>
</template>

<script>
import Upload from './components/trinkets/Upload.vue';
import InputField from './components/trinkets/InputField';

export default {
	name: 'App',
	components: { InputField, Upload },
	data() {
		return {
			drawer: null,
			alertModal: {
				show: false,
				text: '',
			},
			verifyModal: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModal.show = false;
					this.verifyModal.reaction(result);
				},
				reaction: () => {},
			},
			promptModal: {
				show: false,
				text: '',
				value: '',
				result: (result) => {
					this.promptModal.show = false;
					if (result !== false) {
						this.promptModal.reaction(this.promptModal.value);
					} else {
						this.promptModal.reaction(false);
					}
				},
				reaction: () => {},
			},
			notification: {
				show: false,
				text: '',
			},
			initialLoadCompleted: false,
			breadcrumbs: [],
			publicPath: process.env.BASE_URL,
			userManualDialog: false,
			userManual: '',
		};
	},
	computed: {},
	methods: {
		adminUserManual() {
			this.userManualDialog = true;
		},
		closeUserManualDialog() {
			this.userManualDialog = false;
		},
		getUserManual() {
			this.$APICall('get', 'user-manual', {}, (data, succes) => {
				if (succes) {
					if (data) {
						this.userManual = data;
					}
				}
			});
		},
		logoutClick() {
			let vm = this;
			this.$APICall('post', 'logout', {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', null);
					vm.$myStore.commit('setLoggedIn', false);
					vm.$router.push('/login');
				}
			});
		},
		profileClick() {
			this.$router.push('/profile');
		},
		showPDF(fileName) {
			window.open(process.env.BASE_URL + fileName + '.pdf');
		},
		logoReroute() {
			this.$router.push('/members');
		},
		openUserManual() {
			window.open(this.userManual.document.link);
		},

		saveUserManual() {
			let userManual = this.userManual;

			this.$APICall('post', 'user-manual', { userManual }, (data, succes) => {
				if (succes) {
					this.$alert(this.$t('alerts.basicAdd'));
					this.userManual = data;
					this.userManualDialog = false;
				} else {
					this.$alert(this.$t('alerts.basicError'));
				}
			});
		},
	},
	mounted() {
		var vm = this;
		this.$vuetify.theme.themes.light.primary = '#009ec0';
		this.$vuetify.theme.themes.light.secondary = '#858585';

		this.$modalBus.$on('ALERT', (message) => {
			vm.alertModal.text = message;
			vm.alertModal.show = true;
		});
		this.$modalBus.$on('VERIFY', (data) => {
			vm.verifyModal.text = data.message;
			vm.verifyModal.reaction = data.response;
			vm.verifyModal.show = true;
		});
		this.$modalBus.$on('PROMPT', (data) => {
			vm.promptModal.text = data.message;
			vm.promptModal.value = data.initial;
			vm.promptModal.reaction = data.response;
			vm.promptModal.show = true;
		});
		this.$modalBus.$on('NOTIFY', (message) => {
			vm.notification.text = message;
			vm.notification.show = true;
		});

		this.$APICall('get', 'session', {}, (data, success) => {
			if (success) {
				vm.$myStore.commit('setUser', data);
				vm.$myStore.commit('setLoggedIn', true);
				let baseRoutes = ['login', null];
				if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
					vm.$router.push('members');
				}
				vm.initialLoadCompleted = true;
				if (data.version != vm.$getCookie('ide3_version')) {
					vm.$setCookie('ide3_version', data.version, 30);
					window.location.reload(true);
				}
				this.getUserManual();
			} else {
				vm.$APICall('get', 'version', {}, (data, success) => {
					if (success) {
						if (data.version != vm.$getCookie('ide3_version')) {
							vm.$setCookie('ide3_version', data.version, 30);
							window.location.reload(true);
						}
						vm.$myStore.commit('setUser', null);
						vm.$myStore.commit('setLoggedIn', false);
						vm.$router.replace('/login');
						vm.initialLoadCompleted = true;
					}
				});
			}
		});
	},
};
</script>

<style scoped>
.notification {
	z-index: 999999;
}

.loader {
	position: fixed;
	left: 0px;
	top: 0px;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	font-size: 100px;
	text-align: center;
	padding-top: 100px;
}

.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 1s;
}

.fade-to {
	opacity: 1;
}

>>> .cursor-pointer {
	cursor: pointer;
}

>>> .v-main {
	background-color: #ffffff;
}

.menu-footer {
	position: fixed;
	bottom: 10px;
	width: 100%;
	text-align: center;
}

>>> .menu-footer a {
	text-decoration: none;
}

>>> .action-bar {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 9;
	background-color: #efefef;
	text-align: center;
	-webkit-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	-moz-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
}

.navigation-items {
	margin-bottom: 50px;
}
</style>
